export default __webpack_public_path__ + "static/media/blockimg-ebook.6e533971.png";